// @flow
import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import { Box, Container, Text } from 'gestalt';

type Props = {|
  headerLabel?: string,
|};

export default function ProfileBoardsListHeader({ headerLabel }: Props) {
  return (
    <Container>
      <Box
        alignItems="center"
        display="flex"
        marginBottom={2}
        marginLeft={-4}
        marginRight={-4}
        paddingX={3}
      >
        <Box column={9} display="flex" justifyContent="between" paddingX={4}>
          <Text color="gray" size="sm">
            {i18n._('Name', 'Profile header - board name')}
          </Text>
        </Box>
        <Box alignItems="center" column={3} display="flex" paddingX={4}>
          <Text color="gray" size="sm">
            {headerLabel || ''}
          </Text>
        </Box>
      </Box>
    </Container>
  );
}
